<p>tenant-configuration works!</p>
